module.exports = __webpack_public_path__ + "static/supplierbg1_mobile-65c43d95e6d02cf88554b91ba647dd0a.png";